module.exports = __webpack_public_path__ + "b8dc64a8efd7154c70ea781fe9c87128.jpg";